var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Link, NavLink, useLocation } from 'react-router-dom';
import React from 'react';
import Nav from 'react-bootstrap/Nav';
/**
 * A Link that renders as react-router-dom's Link if it's not active.
 *
 * The idea is that if the link is not active (i.e. if active is not explicitly specified, the link is treated as active
 * if the current location's pathname is the same as href) then react-router's NavLink is used to allow client-side
 * navigation similar to a single-page application (SPA). If the link is active, clicking on the link will reload the
 * page.
 */
export function SmartLink(_a) {
    var children = _a.children, to = _a.to, props = __rest(_a, ["children", "to"]);
    var pathname = useLocation().pathname;
    return (React.createElement(Link, __assign({ reloadDocument: pathname === to, to: to }, props), children));
}
/**
 * A Nav.Link that renders as react-router's NavLink if it's not active.
 *
 * The idea is that if the link is not active (i.e. if active is not explicitly specified, the link is treated as active
 * if the current location's pathname is the same as href) then react-router's NavLink is used to allow client-side
 * navigation similar to a single-page application (SPA). If the link is active, clicking on the link will reload the
 * page.
 */
export function SmartNavLink(_a) {
    var children = _a.children, href = _a.href, props = __rest(_a, ["children", "href"]);
    var pathname = useLocation().pathname;
    return (React.createElement(Nav.Link, __assign({ active: pathname === href, as: pathname === href ? undefined : NavLink, eventKey: href, href: href, to: href }, props), children));
}
export function WikiLink(_a) {
    var _b = _a.children, children = _b === void 0 ? 'Wiki' : _b, _c = _a.rel, rel = _c === void 0 ? 'external noopener noreferrer' : _c, props = __rest(_a, ["children", "rel"]);
    return (React.createElement("a", __assign({ rel: rel }, props), children));
}
